import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-100c0db2")

_pushScopeId("data-v-100c0db2")
const _hoisted_1 = {
  key: 0,
  class: "m-4"
}
const _hoisted_2 = { class: "max-w-2xl items-center mx-auto" }
const _hoisted_3 = { class: "max-w-2xl" }
const _hoisted_4 = { class: "px-0 pb-0" }
const _hoisted_5 = { class: "mb-2 mt-2 font-semibold text-2xl text-bp-complementDarker dark:text-bp" }
const _hoisted_6 = {
  alt: "Infos",
  class: "flex flex-wrap mb-4"
}
const _hoisted_7 = { class: "mb-2 font-semibold dark:text-gray-400 text-bp-dark text-sm" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "mx-2" }, "|", -1)
const _hoisted_9 = { class: "mb-2 font-semibold dark:text-gray-400 text-bp-dark text-sm" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "mx-2" }, "|", -1)
const _hoisted_11 = { class: "mb-2 font-semibold dark:text-gray-400 text-bp-dark text-sm" }
const _hoisted_12 = { class: "bg-bp-complementDarker w-auto dark:bg-bp-complementDarker rounded-3xl text-sm text-white dark:text-gray-400 font-extrabold py-0.5 px-2" }
const _hoisted_13 = { class: "mt-0 mb-4 dark:text-gray-400 text-bp-dark font-semibold text-justify text-sm " }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "mt-4" }, null, -1)
const _hoisted_15 = { class: "-mb-4 -mt-2 md:mt-12 text-center" }
const _hoisted_16 = { class: "mt-14 md:mt-4 dark:text-gray-400 text-bp-dark font-semibold justif text-xl" }
const _hoisted_17 = { class: "space-y-4 bp-font-text mx-auto flex-col sm:flex-row md:items-center md:flex flex-wrap justify-center items-center justify-center\n" }
const _hoisted_18 = { class: "flex flex-wrap justify-center" }
const _hoisted_19 = { class: "mt-4 w-auto" }
const _hoisted_20 = { class: "md:mx-4 w-full md:w-ad md:max-w-sm" }
const _hoisted_21 = { class: "justify-between w-full h-auto md:max-w-sm" }
const _hoisted_22 = { class: "mt-4" }
const _hoisted_23 = { class: "text-center mt-4 mb-4 dark:text-gray-400 text-bp-dark font-semibold justif text-xl" }
const _hoisted_24 = { id: "subscribeButton" }
const _hoisted_25 = { class: "mt-4 max-w-2xl items-center mx-auto" }
const _hoisted_26 = { class: "max-w-2xl" }
const _hoisted_27 = { class: "mb-1 font-semibold text-3xl text-bp-complementDarker" }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_btn_close = _resolveComponent("btn-close")
  const _component_subscribe_dialog = _resolveComponent("subscribe-dialog")
  const _component_default_card_layout = _resolveComponent("default-card-layout")
  const _component_default_icon = _resolveComponent("default-icon")
  const _component_default_image_layout = _resolveComponent("default-image-layout")
  const _component_default_ad = _resolveComponent("default-ad")
  const _component_DefaultButton = _resolveComponent("DefaultButton")
  const _component_DefaultSpinner = _resolveComponent("DefaultSpinner")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.boostpackFound)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", null, [
              _createVNode("img", {
                alt: _ctx.boostpackTitleImage,
                src: _ctx.boostpackTitleImage,
                class: "blur-2xl absolute rounded-b-3xl left-0 top-0 object-cover object-top w-full h-95",
                loading: "lazy"
              }, null, 8, ["alt", "src"]),
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_btn_close, {
                  "btn-position": "mr-8 -mt-1",
                  onClose: _ctx.goBackToFeed
                }, null, 8, ["onClose"]),
                _createVNode(_component_default_card_layout, null, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_4, [
                      _createVNode("p", _hoisted_5, _toDisplayString(_ctx.boostpackTitle), 1),
                      _createVNode("div", _hoisted_6, [
                        _createVNode("div", _hoisted_7, [
                          _createTextVNode(_toDisplayString(_ctx.boostpackDate), 1),
                          _hoisted_8
                        ]),
                        _createVNode("div", _hoisted_9, [
                          _createTextVNode(" @" + _toDisplayString(_ctx.boostpackCreator), 1),
                          _hoisted_10
                        ]),
                        _createVNode("div", _hoisted_11, [
                          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.categoryTitle), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_13, [
                        (!_ctx.readMoreActivated)
                          ? (_openBlock(), _createBlock("span", {
                              key: 0,
                              class: "dark:text-gray-400 mb-4 text-bp-dark font-semibold text-justify text-sm ",
                              innerHTML: _ctx.boostpackDescription.slice(0, 500)
                            }, null, 8, ["innerHTML"]))
                          : (_ctx.readMoreActivated)
                            ? (_openBlock(), _createBlock("span", {
                                key: 1,
                                class: "dark:text-gray-400 mb-4 text-bp-dark font-semibold text-justify text-sm ",
                                innerHTML: _ctx.boostpackDescription
                              }, null, 8, ["innerHTML"]))
                            : _createCommentVNode("", true),
                        (_ctx.boostpackDescription.length > 500 && !_ctx.readMoreActivated )
                          ? (_openBlock(), _createBlock("a", {
                              key: 2,
                              class: "cursor-pointer text-bp-light",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleReadMore && _ctx.toggleReadMore(...args)))
                            }, _toDisplayString(_ctx.$t("card.DefaultBoostpackDetail.showMore")), 1))
                          : (_ctx.boostpackDescription.length > 500 && _ctx.readMoreActivated)
                            ? (_openBlock(), _createBlock("a", {
                                key: 3,
                                class: "cursor-pointer text-bp-light",
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleReadMore && _ctx.toggleReadMore(...args)))
                              }, _toDisplayString(_ctx.$t("card.DefaultBoostpackDetail.showLess")), 1))
                            : _createCommentVNode("", true)
                      ]),
                      _hoisted_14,
                      _renderSlot(_ctx.$slots, "subscribeButton", {}, () => [
                        _createVNode(_component_subscribe_dialog, {
                          "prop-boostpack-id": _ctx.boostpack.id
                        }, null, 8, ["prop-boostpack-id"])
                      ])
                    ])
                  ]),
                  _: 3
                })
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _renderSlot(_ctx.$slots, "subscribeButton", {}, () => [
                _createVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("card.DefaultBoostpackDetail.lookInsideText")), 1),
                _createVNode(_component_default_icon, {
                  "css-class": "mx-auto",
                  icon: "dropdown_icon"
                })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.boostpackItems, (boostpackItem, key) => {
                return (_openBlock(), _createBlock("div", {
                  key: boostpackItem.id,
                  id: boostpackItem.reference,
                  class: "space-y-4 bp-font-text flex-col sm:flex-row md:items-center md:flex flex-wrap justify-center items-center justify-center"
                }, [
                  _createVNode("div", _hoisted_19, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(boostpackItem.mediaItems, (boostpackMediaItem) => {
                      return (_openBlock(), _createBlock(_component_default_image_layout, {
                        key: boostpackMediaItem,
                        "show-view-button": false,
                        "alt-image-text": _ctx.getAltImageTextByBoostpackItem(boostpackItem, _ctx.categoryTitle),
                        "detail-image": boostpackMediaItem.thumbMedium,
                        "boostpack-reference": boostpackItem.boostpackReference,
                        item: boostpackItem
                      }, null, 8, ["alt-image-text", "detail-image", "boostpack-reference", "item"]))
                    }), 128))
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", null, [
                        _createVNode(_component_default_ad),
                        _createVNode(_component_default_ad)
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.isAdEnabled(key)]
                  ])
                ], 8, ["id"]))
              }), 128))
            ])
          ]),
          _createVNode("div", _hoisted_22, [
            _renderSlot(_ctx.$slots, "subscribeButton", {}, () => [
              _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("card.DefaultBoostpackDetail.getQuotesText")), 1),
              _createVNode("div", _hoisted_24, [
                _createVNode(_component_subscribe_dialog, { class: "absolute w-auto" })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode(_component_default_card_layout, null, {
                default: _withId(() => [
                  _createVNode("div", null, [
                    _createVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("card.DefaultBoostpackDetail.aboutCreatorTitle")), 1)
                  ]),
                  _createVNode("div", _hoisted_28, [
                    _createVNode("img", {
                      alt: _ctx.boostpackCreatorImage,
                      src: _ctx.boostpackCreatorImage,
                      class: "ml-0 m-4 rounded-3xl w-24 h-24"
                    }, null, 8, ["alt", "src"]),
                    _createVNode("p", {
                      class: "mt-4 mb-4 dark:text-gray-400 text-bp-dark font-semibold text-sm ",
                      innerHTML: _ctx.boostpackCreator
                    }, null, 8, ["innerHTML"])
                  ]),
                  _createVNode(_component_DefaultButton, {
                    "button-text": _ctx.$t('card.DefaultBoostpackDetail.btnBuyACoffee'),
                    "button-color": "bg-bp-complementDarker",
                    "button-hover": "hover:bg-bp-complementDarker",
                    "button-width": "auto",
                    onClickButton: _ctx.buyaCoffe
                  }, null, 8, ["button-text", "onClickButton"])
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_29, [
          _createVNode(_component_DefaultSpinner, {
            "show-spinner": _ctx.isBoostpackLoading(),
            "show-spinner-alternative-text": !_ctx.hasBoostpack() && !_ctx.isBoostpackLoading(),
            spinnerAlternativeText: "Boostpack not found!",
            class: "py-12",
            "spinner-size": "h-12 w-12"
          }, null, 8, ["show-spinner", "show-spinner-alternative-text"])
        ]))
  ]))
})